import * as tslib_1 from "tslib";
import { State, Action, Store, Selector } from '@ngxs/store';
import { filter, take } from 'rxjs/operators';
import { JwtService } from '@app/utils/jwt.service';
var category = 'OAuth';
// eslint-disable-next-line
export var AuthStatus;
(function (AuthStatus) {
    AuthStatus["AUTH_INIT"] = "INIT";
    AuthStatus["AUTH_COMPLETE"] = "COMPLETE";
    AuthStatus["AUTH_VALID"] = "VALID";
    AuthStatus["AUTH_INVALID"] = "INVALID";
    AuthStatus["AUTH_NO_ACCESS"] = "NO_ACCESS";
    AuthStatus["AUTH_NO_REFRESH"] = "NO_REFRESH";
    AuthStatus["AUTH_REFRESHING"] = "REFRESHING";
    AuthStatus["AUTH_IN_PROGRESS"] = "IN_PROGRESS";
})(AuthStatus || (AuthStatus = {}));
var ChangeStatus = /** @class */ (function () {
    function ChangeStatus(status) {
        this.status = status;
    }
    ChangeStatus.type = "[" + category + "] ChangeStatus";
    return ChangeStatus;
}());
export { ChangeStatus };
var SetAuthData = /** @class */ (function () {
    function SetAuthData(url, scopes, user) {
        this.url = url;
        this.scopes = scopes;
        this.user = user;
    }
    SetAuthData.type = "[" + category + "] SetAuthData";
    return SetAuthData;
}());
export { SetAuthData };
var UpdateUser = /** @class */ (function () {
    function UpdateUser(user) {
        this.user = user;
    }
    UpdateUser.type = "[" + category + "] UpdateUser";
    return UpdateUser;
}());
export { UpdateUser };
var AuthState = /** @class */ (function () {
    function AuthState(store, jwt) {
        this.store = store;
        this.jwt = jwt;
    }
    AuthState_1 = AuthState;
    AuthState.status = function (state) {
        return state.status;
    };
    AuthState.baseURL = function (state) {
        return state.baseURL;
    };
    AuthState.hasScope = function (state) {
        return function (scope) { return state.scopes.indexOf(scope.split(':')[0]) >= 0 || state.scopes.indexOf(scope) >= 0; };
    };
    AuthState.user = function (state) {
        return state.user;
    };
    AuthState.prototype.changeStatus = function (ctx, action) {
        ctx.patchState({
            status: action.status,
        });
    };
    AuthState.prototype.setAuthData = function (ctx, action) {
        ctx.patchState({
            baseURL: action.url,
            scopes: action.scopes,
            user: action.user,
        });
    };
    AuthState.prototype.updateUser = function (ctx, action) {
        ctx.patchState({
            user: action.user,
        });
    };
    AuthState.prototype.emitAuthComplete = function () {
        return this.store.select(AuthState_1.status).pipe(filter(function (status) { return status === AuthStatus.AUTH_COMPLETE; }));
    };
    AuthState.prototype.emitAuthInvalid = function () {
        return this.store.select(AuthState_1.status).pipe(filter(function (status) { return status === AuthStatus.AUTH_INVALID; }));
    };
    AuthState.prototype.baseURL = function () {
        return this.store.selectSnapshot(AuthState_1.baseURL);
    };
    AuthState.prototype.userID = function () {
        return this.store.selectSnapshot(AuthState_1.user).id;
    };
    AuthState.prototype.getUser = function () {
        return this.store.select(AuthState_1.user).pipe(filter(function (user) { return !!user && user.id !== 0; }), take(1));
    };
    var AuthState_1;
    tslib_1.__decorate([
        Action(ChangeStatus),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, ChangeStatus]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState.prototype, "changeStatus", null);
    tslib_1.__decorate([
        Action(SetAuthData),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, SetAuthData]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState.prototype, "setAuthData", null);
    tslib_1.__decorate([
        Action(UpdateUser),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object, SetAuthData]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState.prototype, "updateUser", null);
    tslib_1.__decorate([
        Selector([AuthState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState, "status", null);
    tslib_1.__decorate([
        Selector([AuthState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState, "baseURL", null);
    tslib_1.__decorate([
        Selector([AuthState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState, "hasScope", null);
    tslib_1.__decorate([
        Selector([AuthState_1]),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", void 0)
    ], AuthState, "user", null);
    AuthState = AuthState_1 = tslib_1.__decorate([
        State({
            name: 'auth',
            defaults: {
                status: AuthStatus.AUTH_INIT,
                baseURL: '',
                scopes: [],
                user: null,
            },
        }),
        tslib_1.__metadata("design:paramtypes", [Store, JwtService])
    ], AuthState);
    return AuthState;
}());
export { AuthState };
